import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/live-events`;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

/* =========================
   PUBLIC
   ========================= */

export const getAvailableLiveEvents = async (
  limit = 50
) => {
  try {
    const { data } = await axios.get(
      `${apiUrl}/available`,
      {
        params: { limit },
      }
    );

    return data?.events ?? [];
  } catch (error) {
    console.error(
      "getAvailableLiveEvents error:",
      error
    );

    return [];
  }
};

export const getEventLiveHub = async (eventId) => {
  try {
    const id =
      eventId &&
      eventId !== "undefined" &&
      eventId !== "null"
        ? String(eventId)
        : null;

    const url = id
      ? `${apiUrl}/${id}/hub`
      : `${apiUrl}/current/hub`;

    const { data } = await axios.get(url);

    return data;
  } catch (error) {
    console.error(
      "getEventLiveHub error:",
      error
    );

    return null;
  }
};

export const getCurrentLiveHub = async () => {
  try {
    const { data } = await axios.get(
      `${apiUrl}/current/hub`
    );

    return data;
  } catch (error) {
    console.error(
      "getCurrentLiveHub error:",
      error
    );

    return null;
  }
};

/**
 * Bundle complet utilisé par l'écran du dojo.
 */
export const getCastingScreenBundle = async (
  eventId
) => {
  const { data } = await axios.get(
    `${apiUrl}/${eventId}/screen`
  );

  return data;
};

/* =========================
   ADMIN
   ========================= */

export const upsertMatStream = async (
  eventId,
  matNumber,
  payload
) => {
  const { data } = await axios.put(
    `${apiUrl}/${eventId}/mats/${matNumber}/stream`,
    payload,
    {
      headers: authHeaders(),
    }
  );

  return data;
};

export const toggleMatStream = async (
  eventId,
  matNumber
) => {
  const { data } = await axios.patch(
    `${apiUrl}/${eventId}/mats/${matNumber}/stream/toggle`,
    {},
    {
      headers: authHeaders(),
    }
  );

  return data;
};

export const deleteMatStream = async (
  eventId,
  matNumber
) => {
  const { data } = await axios.delete(
    `${apiUrl}/${eventId}/mats/${matNumber}/stream`,
    {
      headers: authHeaders(),
    }
  );

  return data;
};